import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import FinishConfirmDialog from './dialogs/FinishConfirmDialog';
import InitConfirmDialog from './dialogs/InitConfirmDialog';
import UpdatePeriodDialog from './dialogs/UpdatePeriodDialog';
import PeriodForm from './reveal/PeriodForm';
import { withStyles } from '@material-ui/core/styles';

function TabContainer(props) {
  const { children } = props;
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.array.isRequired,
};

/**
 * Function to present the reveal of pricing plans and their actions
 * @param {*} props
 * @returns
 */
function ActionDialogPeriod(props) {
  const {
    openStatus, onClosed, rowData, schoolYear
  } = props;
  const [statusModify, setStatusModify] = React.useState(false);
  const [statusInit, setStatusInit] = React.useState(false);
  const [statusFinish, setStatusFinish] = React.useState(false);

  const [value, setValue] = useState(0);
  const handleChange = (event, valueData) => {
    setValue(valueData);
  };

  const handleClickOpenModify = () => {
    onClosed();
    setStatusModify(true);
  };

  const handleClickCloseModify = () => {
    setStatusModify(false);
  };

  const handleClickOpenInit = () => {
    onClosed();
    setStatusInit(true);
  };

  const handleClickCloseInit = () => {
    setStatusInit(false);
  };

  const handleClickOpenFinish = () => {
    onClosed();
    setStatusFinish(true);
  };

  const handleClickCloseFinish = () => {
    setStatusFinish(false);
  };

  /**
   * Method to close the dialog
   */
  const handleCloseAction = () => {
    onClosed();
  };

  return (

    <Paper>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openStatus}
        onClose={onClosed}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="user-menu-dialog"> Opciones</DialogTitle>
        <DialogContent>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              variant="fullWidth"
              scrollButtons="on"
              indicatorColor="#68dcb9"
              textColor="#ffdf40"
            >
              <Tab style={{backgroundColor: "#ffdf4079"}} label="Información" />

            </Tabs>
          </AppBar>
          {value === 0 && <TabContainer><PeriodForm rowData={rowData}/></TabContainer>}
         
        </DialogContent>
        <DialogActions>
          <Button id="button_close" onClick={handleCloseAction}> Cerrar </Button>
          {rowData[6] === 'Iniciado' ? <Button id="button_finish_period" variant="contained" onClick={handleClickOpenFinish} style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}}> Terminar
          </Button> : ''}
          {rowData[6] === 'Creado' ? <Button id="button_init_period" variant="contained" onClick={handleClickOpenInit} style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}}> Iniciar
          </Button> : ''}
          {rowData[6] === 'Terminado' ? '' : <Button id="button_modify_period" variant="contained" onClick={handleClickOpenModify} style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}}> Modificar
          </Button>}
        </DialogActions>
      </Dialog>

      <InitConfirmDialog openStatusConfirm={statusInit} onClosedConfirm= {handleClickCloseInit} rowData={rowData}/>
      <FinishConfirmDialog openStatusConfirm={statusFinish} onClosedConfirm= {handleClickCloseFinish} rowData={rowData}/>
      <UpdatePeriodDialog openStatus={statusModify} onClosed= {handleClickCloseModify} rowData={rowData} schoolYear={schoolYear}/>
    </Paper>

  );
}

ActionDialogPeriod.propTypes = {
  /** Style classes */
  openStatus: PropTypes.bool.isRequired,
  /** Function of modify dialog */
  onClosed: PropTypes.func.isRequired,
  /** Array of pricing plan */
  rowData: PropTypes.array.isRequired,
   /** Array of pricing plan */
  schoolYear: PropTypes.array.isRequired
};

export default ActionDialogPeriod;
